import { Button } from '@progress/kendo-react-buttons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { DashboardTileHeader } from '../../components/dashboard/dashboard-tile-header.tsx';
import { DashboardTileContent } from '../../components/dashboard/dashboard-tile-content.tsx';
import { formatDate } from '@progress/kendo-intl';
import type { JobWeekTileProps } from './job-week-tile.types.ts';
import styles from './job-week-tile.module.scss';

export function JobWeekTile({ weekStart, plannedCount }: JobWeekTileProps) {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate('/sampling-board/planning');
  };

  return (
    <>
      <DashboardTileHeader>
        Job Week Report
        <Button onClick={handleNavigate}>
          <FontAwesomeIcon icon={faArrowRight} size={'sm'} />
        </Button>
      </DashboardTileHeader>
      <DashboardTileContent className={styles.content}>
        <div className={styles.contentSection}>
          <span className={styles.contentTitle}>{formatDate(weekStart, 'dd MMM yy')}</span>
          <span className={styles.contentValue}>Week Starting</span>
        </div>
        <div className={styles.contentSeparator}></div>
        <div className={styles.contentSection}>
          <span className={styles.contentTitle}>{plannedCount}</span>
          <span className={styles.contentValue}>Planned Jobs</span>
        </div>
      </DashboardTileContent>
    </>
  );
}
